module.exports = __webpack_public_path__ + "img/hip-ectomorph-male.cafb4e81.svg";